module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAARCAYAAAAougcOAAABS0lEQVQ4jWM8wsBwiIGBgYmBduADCwMDgxUDAwMzDS35xERjX4DAX5AF/2hsyR+svhDMzmYwefmSwfr/fzCWnTMHLgcTw4Y5nJyw2sKCLgBSqDVlCsOjuXMZHqekgC1U6+xk+PPxI8Pz4mKGVzt3MrBLSjJc0dcn2isYPpHMyGD4+eoV2AIQeD91KsPHixcZ+C0siDaUoCVv1q1juJmfjyLGo6LC8PPpU7ItwQiuzytWICTV1Bh0tm8Hsx/X1MDF+fX0wHGADO719YGDkyhLYAAUNzrLlzP8+fKF4YKtLcOfW7fgch8vXaIsTkCANyKCQX/TJoYfL14wXFBWRrGAHIBhCSg16S1fzvDuyBGSXIsPYASXiK8vmBZzd2cQQwv3o4yM1LHktocHw23KHY8CQKXwHxoXkK9BcUJeGBAPWEHB9ZqGJTEjAwPDWwBxIXR/a08RiAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/nxyp1/2F.png
// module id = FlQp
// module chunks = 0